const repairJudgeMeSummary = (root = document) => {
  for (const summary of root.querySelectorAll('.jdgm-rev-widg__summary-stars[role="img"]')) {
    if (summary.querySelector('a')) {
      summary.removeAttribute('role');
      summary.removeAttribute('aria-label');
    }
  }
};

repairJudgeMeSummary();

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) repairJudgeMeSummary(node);
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });
